import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "record-row__label" }
const _hoisted_2 = { class: "record-row__value" }
const _hoisted_3 = {
  "data-test": "record-row-action",
  class: "record-row__action"
}


export default {
  __name: 'RecordRow',
  props: {
  label: { type: String, required: true },
  active: { type: Boolean, default: false }
},
  setup(__props) {



return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["record-row", __props.active && 'record-row--active'])
  }, [
    _createElementVNode("dt", _hoisted_1, _toDisplayString(__props.label), 1),
    _createElementVNode("dd", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "action")
    ])
  ], 2))
}
}

}